// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2mo9f","colCheckbox":"styles_colCheckbox__QBLAY"};